import { render, staticRenderFns } from "./DmDriverLabelForm.vue?vue&type=template&id=9b02b576"
import script from "./DmDriverLabelForm.vue?vue&type=script&lang=js"
export * from "./DmDriverLabelForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports